import type { ReactNode } from "react";
import { ChevronRightIcon } from "lucide-react";

/** A readable lead with the evidence one keyboard-accessible disclosure away. */
export function DecisionBrief({ summary, label, children }: {
  readonly summary: string;
  readonly label: string;
  readonly children: ReactNode;
}) {
  return (
    <div className="mt-3 border-l-2 border-primary/25 pl-3">
      <p aria-label="In brief" className="text-sm leading-6 text-foreground">
        {summary || "No summary was recorded. Read the supporting details before deciding."}
      </p>
      <details className="group/brief mt-1.5">
        <summary className="pointer-events-auto flex w-fit cursor-pointer list-none items-center gap-1 text-xs font-medium text-muted-foreground hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring [&::-webkit-details-marker]:hidden">
          <ChevronRightIcon aria-hidden className="size-3.5 group-open/brief:rotate-90" />
          {label}
        </summary>
        <div className="mt-3 space-y-3 text-sm leading-6 text-muted-foreground">{children}</div>
      </details>
    </div>
  );
}
